/**
 * Copia um texto para a área de transferência.
 *
 * `navigator.clipboard` é tipado como sempre presente pela lib DOM, mas não
 * existe em contexto inseguro (HTTP) e a escrita pode ser negada por permissão.
 * A falha é devolvida como `false` em vez de propagar a exceção, para que quem
 * chama decida o feedback ao operador em vez de quebrar a renderização.
 *
 * @param value - Texto a copiar. Sempre o valor completo, nunca uma versão
 *   truncada para exibição.
 * @returns `true` quando a escrita foi confirmada; `false` quando a API não
 *   está disponível ou a escrita foi rejeitada.
 *
 * @example
 * ```ts
 * const copied = await copyToClipboard(serial.digitableLine ?? '');
 * alert({ alertType: copied ? 'success' : 'danger', title: '...' });
 * ```
 */
export async function copyToClipboard(value: string): Promise<boolean> {
  const clipboard = navigator.clipboard as Clipboard | undefined;
  if (typeof clipboard?.writeText !== 'function') return false;

  try {
    await clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
}
